module.exports = __webpack_public_path__ + "img/23.c879a84c.jpg";